import { BillingInformationModel } from '../api/billing-types';

export const states = [
  { abbreviation: 'AL', displayValue: 'Alabama' },
  { abbreviation: 'AK', displayValue: 'Alaska' },
  { abbreviation: 'AS', displayValue: 'American Samoa' },
  { abbreviation: 'AZ', displayValue: 'Arizona' },
  { abbreviation: 'AR', displayValue: 'Arkansas' },
  { abbreviation: 'CA', displayValue: 'California' },
  { abbreviation: 'CO', displayValue: 'Colorado' },
  { abbreviation: 'CT', displayValue: 'Connecticut' },
  { abbreviation: 'DE', displayValue: 'Delaware' },
  { abbreviation: 'DC', displayValue: 'District of Columbia' },
  { abbreviation: 'FM', displayValue: 'Federated States of Micronesia' },
  { abbreviation: 'FL', displayValue: 'Florida' },
  { abbreviation: 'GA', displayValue: 'Georgia' },
  { abbreviation: 'GU', displayValue: 'Guam' },
  { abbreviation: 'HI', displayValue: 'Hawaii' },
  { abbreviation: 'ID', displayValue: 'Idaho' },
  { abbreviation: 'IL', displayValue: 'Illinois' },
  { abbreviation: 'IN', displayValue: 'Indiana' },
  { abbreviation: 'IA', displayValue: 'Iowa' },
  { abbreviation: 'KS', displayValue: 'Kansas' },
  { abbreviation: 'KY', displayValue: 'Kentucky' },
  { abbreviation: 'LA', displayValue: 'Louisiana' },
  { abbreviation: 'ME', displayValue: 'Maine' },
  { abbreviation: 'MD', displayValue: 'Maryland' },
  { abbreviation: 'MH', displayValue: 'Marshall Islands' },
  { abbreviation: 'MA', displayValue: 'Massachusetts' },
  { abbreviation: 'MI', displayValue: 'Michigan' },
  { abbreviation: 'MN', displayValue: 'Minnesota' },
  { abbreviation: 'MS', displayValue: 'Mississippi' },
  { abbreviation: 'MO', displayValue: 'Missouri' },
  { abbreviation: 'MT', displayValue: 'Montana' },
  { abbreviation: 'NE', displayValue: 'Nebraska' },
  { abbreviation: 'NV', displayValue: 'Nevada' },
  { abbreviation: 'NH', displayValue: 'New Hampshire' },
  { abbreviation: 'NJ', displayValue: 'New Jersey' },
  { abbreviation: 'NM', displayValue: 'New Mexico' },
  { abbreviation: 'NY', displayValue: 'New York' },
  { abbreviation: 'NC', displayValue: 'North Carolina' },
  { abbreviation: 'ND', displayValue: 'North Dakota' },
  { abbreviation: 'MP', displayValue: 'Northern Mariana Islands' },
  { abbreviation: 'OH', displayValue: 'Ohio' },
  { abbreviation: 'OK', displayValue: 'Oklahoma' },
  { abbreviation: 'OR', displayValue: 'Oregon' },
  { abbreviation: 'PW', displayValue: 'Palau' },
  { abbreviation: 'PA', displayValue: 'Pennsylvania' },
  { abbreviation: 'PR', displayValue: 'Puerto Rico' },
  { abbreviation: 'RI', displayValue: 'Rhode Island' },
  { abbreviation: 'SC', displayValue: 'South Carolina' },
  { abbreviation: 'SD', displayValue: 'South Dakota' },
  { abbreviation: 'TN', displayValue: 'Tennessee' },
  { abbreviation: 'TX', displayValue: 'Texas' },
  { abbreviation: 'UT', displayValue: 'Utah' },
  { abbreviation: 'VT', displayValue: 'Vermont' },
  { abbreviation: 'VI', displayValue: 'Virgin Islands' },
  { abbreviation: 'VA', displayValue: 'Virginia' },
  { abbreviation: 'WA', displayValue: 'Washington' },
  { abbreviation: 'WV', displayValue: 'West Virginia' },
  { abbreviation: 'WI', displayValue: 'Wisconsin' },
  { abbreviation: 'WY', displayValue: 'Wyoming' },
  { abbreviation: '', displayValue: 'Unknown' },
];

export const countries = [
  { abbreviation: 'US', displayValue: 'United States' },
  { abbreviation: 'AF', displayValue: 'Afghanistan' },
  { abbreviation: 'AX', displayValue: 'Aland Islands' },
  { abbreviation: 'AL', displayValue: 'Albania' },
  { abbreviation: 'DZ', displayValue: 'Algeria' },
  { abbreviation: 'AS', displayValue: 'American Samoa' },
  { abbreviation: 'AD', displayValue: 'Andorra' },
  { abbreviation: 'AO', displayValue: 'Angola' },
  { abbreviation: 'AI', displayValue: 'Anguilla' },
  { abbreviation: 'AQ', displayValue: 'Antarctica' },
  { abbreviation: 'AG', displayValue: 'Antigua and Barbuda' },
  { abbreviation: 'AR', displayValue: 'Argentina' },
  { abbreviation: 'AM', displayValue: 'Armenia' },
  { abbreviation: 'AW', displayValue: 'Aruba' },
  { abbreviation: 'AU', displayValue: 'Australia' },
  { abbreviation: 'AT', displayValue: 'Austria' },
  { abbreviation: 'AZ', displayValue: 'Azerbaijan' },
  { abbreviation: 'BS', displayValue: 'Bahamas' },
  { abbreviation: 'BH', displayValue: 'Bahrain' },
  { abbreviation: 'BD', displayValue: 'Bangladesh' },
  { abbreviation: 'BB', displayValue: 'Barbados' },
  { abbreviation: 'BY', displayValue: 'Belarus' },
  { abbreviation: 'BE', displayValue: 'Belgium' },
  { abbreviation: 'BZ', displayValue: 'Belize' },
  { abbreviation: 'BJ', displayValue: 'Benin' },
  { abbreviation: 'BM', displayValue: 'Bermuda' },
  { abbreviation: 'BT', displayValue: 'Bhutan' },
  { abbreviation: 'BO', displayValue: 'Bolivia' },
  { abbreviation: 'BA', displayValue: 'Bosnia and Herzegovina' },
  { abbreviation: 'BW', displayValue: 'Botswana' },
  { abbreviation: 'BV', displayValue: 'Bouvet Island' },
  { abbreviation: 'BR', displayValue: 'Brazil' },
  { abbreviation: 'IO', displayValue: 'British Indian Ocean Territory' },
  { abbreviation: 'VG', displayValue: 'British Virgin Islands' },
  { abbreviation: 'BN', displayValue: 'Brunei' },
  { abbreviation: 'BG', displayValue: 'Bulgaria' },
  { abbreviation: 'BF', displayValue: 'Burkina Faso' },
  { abbreviation: 'BI', displayValue: 'Burundi' },
  { abbreviation: 'KH', displayValue: 'Cambodia' },
  { abbreviation: 'CM', displayValue: 'Cameroon' },
  { abbreviation: 'CA', displayValue: 'Canada' },
  { abbreviation: 'CV', displayValue: 'Cape Verde' },
  { abbreviation: 'KY', displayValue: 'Cayman Islands' },
  { abbreviation: 'CF', displayValue: 'Central African Republic' },
  { abbreviation: 'TD', displayValue: 'Chad' },
  { abbreviation: 'CL', displayValue: 'Chile' },
  { abbreviation: 'CN', displayValue: 'China' },
  { abbreviation: 'CX', displayValue: 'Christmas Island' },
  { abbreviation: 'CC', displayValue: 'Cocos [Keeling] Islands' },
  { abbreviation: 'CO', displayValue: 'Colombia' },
  { abbreviation: 'KM', displayValue: 'Comoros' },
  { abbreviation: 'CG', displayValue: 'Congo - Brazzaville' },
  { abbreviation: 'CD', displayValue: 'Congo - Kinshasa' },
  { abbreviation: 'CK', displayValue: 'Cook Islands' },
  { abbreviation: 'CR', displayValue: 'Costa Rica' },
  { abbreviation: 'HR', displayValue: 'Croatia' },
  { abbreviation: 'CU', displayValue: 'Cuba' },
  { abbreviation: 'CY', displayValue: 'Cyprus' },
  { abbreviation: 'CZ', displayValue: 'Czech Republic' },
  { abbreviation: 'CI', displayValue: "Cote d'Ivoire" },
  { abbreviation: 'DK', displayValue: 'Denmark' },
  { abbreviation: 'DJ', displayValue: 'Djibouti' },
  { abbreviation: 'DM', displayValue: 'Dominica' },
  { abbreviation: 'DO', displayValue: 'Dominican Republic' },
  { abbreviation: 'EC', displayValue: 'Ecuador' },
  { abbreviation: 'EG', displayValue: 'Egypt' },
  { abbreviation: 'SV', displayValue: 'El Salvador' },
  { abbreviation: 'GQ', displayValue: 'Equatorial Guinea' },
  { abbreviation: 'ER', displayValue: 'Eritrea' },
  { abbreviation: 'EE', displayValue: 'Estonia' },
  { abbreviation: 'ET', displayValue: 'Ethiopia' },
  { abbreviation: 'FK', displayValue: 'Falkland Islands' },
  { abbreviation: 'FO', displayValue: 'Faroe Islands' },
  { abbreviation: 'FJ', displayValue: 'Fiji' },
  { abbreviation: 'FI', displayValue: 'Finland' },
  { abbreviation: 'FR', displayValue: 'France' },
  { abbreviation: 'GF', displayValue: 'French Guiana' },
  { abbreviation: 'PF', displayValue: 'French Polynesia' },
  { abbreviation: 'TF', displayValue: 'French Southern Territories' },
  { abbreviation: 'GA', displayValue: 'Gabon' },
  { abbreviation: 'GM', displayValue: 'Gambia' },
  { abbreviation: 'GE', displayValue: 'Georgia' },
  { abbreviation: 'DE', displayValue: 'Germany' },
  { abbreviation: 'GH', displayValue: 'Ghana' },
  { abbreviation: 'GI', displayValue: 'Gibraltar' },
  { abbreviation: 'GR', displayValue: 'Greece' },
  { abbreviation: 'GL', displayValue: 'Greenland' },
  { abbreviation: 'GD', displayValue: 'Grenada' },
  { abbreviation: 'GP', displayValue: 'Guadeloupe' },
  { abbreviation: 'GU', displayValue: 'Guam' },
  { abbreviation: 'GT', displayValue: 'Guatemala' },
  { abbreviation: 'GG', displayValue: 'Guernsey' },
  { abbreviation: 'GN', displayValue: 'Guinea' },
  { abbreviation: 'GW', displayValue: 'Guinea-Bissau' },
  { abbreviation: 'GY', displayValue: 'Guyana' },
  { abbreviation: 'HT', displayValue: 'Haiti' },
  { abbreviation: 'HM', displayValue: 'Heard Island and McDonald Islands' },
  { abbreviation: 'HN', displayValue: 'Honduras' },
  { abbreviation: 'HK', displayValue: 'Hong Kong SAR China' },
  { abbreviation: 'HU', displayValue: 'Hungary' },
  { abbreviation: 'IS', displayValue: 'Iceland' },
  { abbreviation: 'IN', displayValue: 'India' },
  { abbreviation: 'ID', displayValue: 'Indonesia' },
  { abbreviation: 'IR', displayValue: 'Iran' },
  { abbreviation: 'IQ', displayValue: 'Iraq' },
  { abbreviation: 'IE', displayValue: 'Ireland' },
  { abbreviation: 'IM', displayValue: 'Isle of Man' },
  { abbreviation: 'IL', displayValue: 'Israel' },
  { abbreviation: 'IT', displayValue: 'Italy' },
  { abbreviation: 'JM', displayValue: 'Jamaica' },
  { abbreviation: 'JP', displayValue: 'Japan' },
  { abbreviation: 'JE', displayValue: 'Jersey' },
  { abbreviation: 'JO', displayValue: 'Jordan' },
  { abbreviation: 'KZ', displayValue: 'Kazakhstan' },
  { abbreviation: 'KE', displayValue: 'Kenya' },
  { abbreviation: 'KI', displayValue: 'Kiribati' },
  { abbreviation: 'KW', displayValue: 'Kuwait' },
  { abbreviation: 'KG', displayValue: 'Kyrgyzstan' },
  { abbreviation: 'LA', displayValue: 'Laos' },
  { abbreviation: 'LV', displayValue: 'Latvia' },
  { abbreviation: 'LB', displayValue: 'Lebanon' },
  { abbreviation: 'LS', displayValue: 'Lesotho' },
  { abbreviation: 'LR', displayValue: 'Liberia' },
  { abbreviation: 'LY', displayValue: 'Libya' },
  { abbreviation: 'LI', displayValue: 'Liechtenstein' },
  { abbreviation: 'LT', displayValue: 'Lithuania' },
  { abbreviation: 'LU', displayValue: 'Luxembourg' },
  { abbreviation: 'MO', displayValue: 'Macau SAR China' },
  { abbreviation: 'MK', displayValue: 'Macedonia' },
  { abbreviation: 'MG', displayValue: 'Madagascar' },
  { abbreviation: 'MW', displayValue: 'Malawi' },
  { abbreviation: 'MY', displayValue: 'Malaysia' },
  { abbreviation: 'MV', displayValue: 'Maldives' },
  { abbreviation: 'ML', displayValue: 'Mali' },
  { abbreviation: 'MT', displayValue: 'Malta' },
  { abbreviation: 'MH', displayValue: 'Marshall Islands' },
  { abbreviation: 'MQ', displayValue: 'Martinique' },
  { abbreviation: 'MR', displayValue: 'Mauritania' },
  { abbreviation: 'MU', displayValue: 'Mauritius' },
  { abbreviation: 'YT', displayValue: 'Mayotte' },
  { abbreviation: 'MX', displayValue: 'Mexico' },
  { abbreviation: 'FM', displayValue: 'Micronesia' },
  { abbreviation: 'MD', displayValue: 'Moldova' },
  { abbreviation: 'MC', displayValue: 'Monaco' },
  { abbreviation: 'MN', displayValue: 'Mongolia' },
  { abbreviation: 'ME', displayValue: 'Montenegro' },
  { abbreviation: 'MS', displayValue: 'Montserrat' },
  { abbreviation: 'MA', displayValue: 'Morocco' },
  { abbreviation: 'MZ', displayValue: 'Mozambique' },
  { abbreviation: 'MM', displayValue: 'Myanmar [Burma]' },
  { abbreviation: 'NA', displayValue: 'Namibia' },
  { abbreviation: 'NR', displayValue: 'Nauru' },
  { abbreviation: 'NP', displayValue: 'Nepal' },
  { abbreviation: 'NL', displayValue: 'Netherlands' },
  { abbreviation: 'AN', displayValue: 'Netherlands Antilles' },
  { abbreviation: 'NC', displayValue: 'New Caledonia' },
  { abbreviation: 'NZ', displayValue: 'New Zealand' },
  { abbreviation: 'NI', displayValue: 'Nicaragua' },
  { abbreviation: 'NE', displayValue: 'Niger' },
  { abbreviation: 'NG', displayValue: 'Nigeria' },
  { abbreviation: 'NU', displayValue: 'Niue' },
  { abbreviation: 'NF', displayValue: 'Norfolk Island' },
  { abbreviation: 'KP', displayValue: 'North Korea' },
  { abbreviation: 'MP', displayValue: 'Northern Mariana Islands' },
  { abbreviation: 'NO', displayValue: 'Norway' },
  { abbreviation: 'OM', displayValue: 'Oman' },
  { abbreviation: 'PK', displayValue: 'Pakistan' },
  { abbreviation: 'PW', displayValue: 'Palau' },
  { abbreviation: 'PS', displayValue: 'Palestinian Territories' },
  { abbreviation: 'PA', displayValue: 'Panama' },
  { abbreviation: 'PG', displayValue: 'Papua New Guinea' },
  { abbreviation: 'PY', displayValue: 'Paraguay' },
  { abbreviation: 'PE', displayValue: 'Peru' },
  { abbreviation: 'PH', displayValue: 'Philippines' },
  { abbreviation: 'PN', displayValue: 'Pitcairn Islands' },
  { abbreviation: 'PL', displayValue: 'Poland' },
  { abbreviation: 'PT', displayValue: 'Portugal' },
  { abbreviation: 'PR', displayValue: 'Puerto Rico' },
  { abbreviation: 'QA', displayValue: 'Qatar' },
  { abbreviation: 'RO', displayValue: 'Romania' },
  { abbreviation: 'RU', displayValue: 'Russia' },
  { abbreviation: 'RW', displayValue: 'Rwanda' },
  { abbreviation: 'RE', displayValue: 'Reunion' },
  { abbreviation: 'BL', displayValue: 'Saint Barthelemy' },
  { abbreviation: 'SH', displayValue: 'Saint Helena' },
  { abbreviation: 'KN', displayValue: 'Saint Kitts and Nevis' },
  { abbreviation: 'LC', displayValue: 'Saint Lucia' },
  { abbreviation: 'MF', displayValue: 'Saint Martin' },
  { abbreviation: 'PM', displayValue: 'Saint Pierre and Miquelon' },
  { abbreviation: 'VC', displayValue: 'Saint Vincent and the Grenadines' },
  { abbreviation: 'WS', displayValue: 'Samoa' },
  { abbreviation: 'SM', displayValue: 'San Marino' },
  { abbreviation: 'SA', displayValue: 'Saudi Arabia' },
  { abbreviation: 'SN', displayValue: 'Senegal' },
  { abbreviation: 'RS', displayValue: 'Serbia' },
  { abbreviation: 'SC', displayValue: 'Seychelles' },
  { abbreviation: 'SL', displayValue: 'Sierra Leone' },
  { abbreviation: 'SG', displayValue: 'Singapore' },
  { abbreviation: 'SK', displayValue: 'Slovakia' },
  { abbreviation: 'SI', displayValue: 'Slovenia' },
  { abbreviation: 'SB', displayValue: 'Solomon Islands' },
  { abbreviation: 'SO', displayValue: 'Somalia' },
  { abbreviation: 'ZA', displayValue: 'South Africa' },
  {
    abbreviation: 'GS',
    displayValue: 'South Georgia and the South Sandwich Islands',
  },
  { abbreviation: 'KR', displayValue: 'South Korea' },
  { abbreviation: 'ES', displayValue: 'Spain' },
  { abbreviation: 'LK', displayValue: 'Sri Lanka' },
  { abbreviation: 'SD', displayValue: 'Sudan' },
  { abbreviation: 'SR', displayValue: 'Suriname' },
  { abbreviation: 'SJ', displayValue: 'Svalbard and Jan Mayen' },
  { abbreviation: 'SZ', displayValue: 'Swaziland' },
  { abbreviation: 'SE', displayValue: 'Sweden' },
  { abbreviation: 'CH', displayValue: 'Switzerland' },
  { abbreviation: 'SY', displayValue: 'Syria' },
  { abbreviation: 'ST', displayValue: 'Sao Tome and Principe' },
  { abbreviation: 'TW', displayValue: 'Taiwan' },
  { abbreviation: 'TJ', displayValue: 'Tajikistan' },
  { abbreviation: 'TZ', displayValue: 'Tanzania' },
  { abbreviation: 'TH', displayValue: 'Thailand' },
  { abbreviation: 'TL', displayValue: 'Timor-Leste' },
  { abbreviation: 'TG', displayValue: 'Togo' },
  { abbreviation: 'TK', displayValue: 'Tokelau' },
  { abbreviation: 'TO', displayValue: 'Tonga' },
  { abbreviation: 'TT', displayValue: 'Trinidad and Tobago' },
  { abbreviation: 'TN', displayValue: 'Tunisia' },
  { abbreviation: 'TR', displayValue: 'Turkey' },
  { abbreviation: 'TM', displayValue: 'Turkmenistan' },
  { abbreviation: 'TC', displayValue: 'Turks and Caicos Islands' },
  { abbreviation: 'TV', displayValue: 'Tuvalu' },
  { abbreviation: 'UM', displayValue: 'U.S. Minor Outlying Islands' },
  { abbreviation: 'VI', displayValue: 'U.S. Virgin Islands' },
  { abbreviation: 'UG', displayValue: 'Uganda' },
  { abbreviation: 'UA', displayValue: 'Ukraine' },
  { abbreviation: 'AE', displayValue: 'United Arab Emirates' },
  { abbreviation: 'GB', displayValue: 'United Kingdom' },
  { abbreviation: 'UY', displayValue: 'Uruguay' },
  { abbreviation: 'UZ', displayValue: 'Uzbekistan' },
  { abbreviation: 'VU', displayValue: 'Vanuatu' },
  { abbreviation: 'VA', displayValue: 'Vatican City' },
  { abbreviation: 'VE', displayValue: 'Venezuela' },
  { abbreviation: 'VN', displayValue: 'Vietnam' },
  { abbreviation: 'WF', displayValue: 'Wallis and Futuna' },
  { abbreviation: 'EH', displayValue: 'Western Sahara' },
  { abbreviation: 'YE', displayValue: 'Yemen' },
  { abbreviation: 'ZM', displayValue: 'Zambia' },
  { abbreviation: 'ZW', displayValue: 'Zimbabwe' },
];

export function validatePrimaryBillingContact(
  billingInformationModel: BillingInformationModel
) {
  if (
    !billingInformationModel.emailAddress ||
    billingInformationModel.emailAddress.trim() === ''
  ) {
    throw new Error('Missing required fields');
  }

  if (
    !billingInformationModel.shippingAddress.streetAddress ||
    billingInformationModel.shippingAddress.streetAddress.trim() === '' ||
    !billingInformationModel.shippingAddress.zipCode ||
    billingInformationModel.shippingAddress.zipCode.trim() === '' ||
    !billingInformationModel.shippingAddress.state ||
    billingInformationModel.shippingAddress.state.trim() === '' ||
    !billingInformationModel.shippingAddress.city ||
    billingInformationModel.shippingAddress.city.trim() === '' ||
    !billingInformationModel.shippingAddress.country ||
    billingInformationModel.shippingAddress.country.trim() === '' ||
    !billingInformationModel.billingAddress.streetAddress ||
    billingInformationModel.billingAddress.streetAddress.trim() === '' ||
    !billingInformationModel.billingAddress.city ||
    billingInformationModel.billingAddress.city.trim() === '' ||
    !billingInformationModel.billingAddress.state ||
    billingInformationModel.billingAddress.state.trim() === '' ||
    !billingInformationModel.billingAddress.zipCode ||
    billingInformationModel.billingAddress.zipCode.trim() === '' ||
    !billingInformationModel.billingAddress.country ||
    billingInformationModel.billingAddress.country.trim() === ''
  ) {
    throw new Error('Missing required fields');
  }

  if (billingInformationModel.shippingAddress.country === 'US') {
    if (
      !states.some(
        (state) =>
          state.abbreviation ===
          billingInformationModel.shippingAddress.state.trim()
      )
    ) {
      throw new Error('Invalid shipping address state format');
    }
  }

  if (
    !countries.some(
      (country) =>
        country.abbreviation ===
        billingInformationModel.shippingAddress.country.trim()
    )
  ) {
    throw new Error('Invalid shipping address country format');
  }

  if (billingInformationModel.billingAddress.country === 'US') {
    if (
      !states.some(
        (state) =>
          state.abbreviation ===
          billingInformationModel.billingAddress.state.trim()
      )
    ) {
      throw new Error('Invalid billing address state format');
    }
  }

  if (
    !countries.some(
      (country) =>
        country.abbreviation ===
        billingInformationModel.billingAddress.country.trim()
    )
  ) {
    throw new Error('Invalid billing address country format');
  }
}
